import { MASKED_CARD_NUMBER } from '@/common/constants';

interface CardNumberData {
  last4?: string;
  last2?: string;
}

export const getDisplayCardNumber = (
  cardData: CardNumberData,
  hasFullCardNumberPermission: boolean
): string => {
  if (hasFullCardNumberPermission && cardData.last4) {
    return `${MASKED_CARD_NUMBER}${cardData.last4}`;
  }
  
  if (cardData.last2) {
    return `••${cardData.last2}`;
  }
  
  return MASKED_CARD_NUMBER;
};

export const getCardNumberLabel = (
  cardData: CardNumberData,
  hasFullCardNumberPermission: boolean
): string => {
  if (hasFullCardNumberPermission && cardData.last4) {
    return 'Primary card info (last 4 digits)';
  }
  
  return 'Primary card info (last 2 digits)';
};